import { Component, OnInit, ViewChild, HostListener, ElementRef } from "@angular/core";
import { AuthGuard } from "../../core/helper/auth.guard";

import { LocalStorage } from "../../core/helper/localStorage";
import { AppConstants } from "../../app.constant";
import { BaseComponent } from "../../core/component/Base.Component";
import { GenEnum } from "../shared/general.enum";
import * as moment from 'moment';
import { SMStudentinfoService } from "../forms/school-management/transaction/studentprofile/studentprofile.service";
import { EmployeeinfohdrService } from "../forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { IXSModalComponent } from "../../components/ixsmodal/ixsmodal.component";
import { StudentBirthday } from "./Student-birthday/Studbirthday.component";
import { SMMessageService } from "../forms/Communication/Message/SMMessage.service";
import { TemplateService } from "../forms/organizational-setup/setup/template/template.service";
import { StudentguardianService } from "../forms/school-management/transaction/studentguardianlist/studentguardian/studentguardian.service";
import { IxsKeymodalComponent } from "../../components/ixs-keymodal/ixs-keymodal.component";
import { SystemPolicyService } from "../forms/organizational-setup/setup/systempolicy/systempolicy.service";
import { ErrorComponent } from "../../components/error/error.component";
import { InstituteService } from "../forms/organizational-setup/setup/institute/institute.service";
import { ImageService } from "../shared/image.service";
import { ActivatedRoute, NavigationExtras } from "@angular/router";
import { element } from "@angular/upgrade/src/angular_js";
import { MenusService } from "../../core/service/menus.service";
import { EmployeeBirthday } from "./Employee-Birthday/Employeebirthday.component";

interface Item {
  label: string;
  children?: Item[];
}
@Component({
  moduleId: module.id,
  selector: "navigation-bar",
  templateUrl: "../shell-templates/navigation-bar.component.html"
})
export class NavigationBarComponent extends BaseComponent {
  imagesourceentity: string;
  protected localStorage: LocalStorage;
  imageSource: any;
  today: number = Date.now();
  time: Date;
  url: string;
  tree: Array<any>;
  rolestxt: string;
  model: any = {};
  userclients: any;
  userurl: any;
  entitycount: any;
  dropdown: boolean = false
  campFilter: any = { stxt: '' };
  isModalOpen: boolean = false;
  @ViewChild('Birthdaymodal') birthdaymodal: IXSModalComponent;
  @ViewChild('empBirthdaymodal') empBirthdaymodal: IXSModalComponent;
  @ViewChild('stubirthdayScreen') stubirthdayScreen: StudentBirthday;
  @ViewChild('EmpbirthdayScreen') EmpbirthdayScreen: EmployeeBirthday;
  @ViewChild('changepass') changepass: IXSModalComponent;
  @ViewChild("error") errorForm: ErrorComponent;
  @ViewChild('searchbarinput') searchInput: ElementRef;

  constructor(private auth: AuthGuard,
    private route: ActivatedRoute,
    private menusService: MenusService,
    private _SMStudentinfoService: SMStudentinfoService,
    private SystemPolicyservice: SystemPolicyService,
    private instituteService: InstituteService,
    private _GNImage: ImageService,
    // private location: Location,
    private _EmployeeinfohdrService: EmployeeinfohdrService) {
    super();

    this.localStorage = AppConstants.injector.get(LocalStorage);
    this.imageSource =
      AppConstants.urls.api.base.replace("api/", "") + GenEnum.Image.imageUrl;

    this.imagesourceentity = this.localStorage.get('OnlyUrl') + GenEnum.Image.imageUrl;

    $(".dropdown a").click(function () {
      $(this).parent(".dropdown").children("div").slideToggle("200");
      $(this).find("i.fa").toggleClass("fa fa-birthday-cake cake-icon");
    });
  }

  studentbirthday: any[] = [];
  birthdayEmployee: any[] = [];
  onclickopen: Boolean;
  Etotal: number = 0;
  Stotal: number = 0;
  total: number = 0;

  getCurrenDate() {
    setInterval(() => {
      var d = new Date(); // for now
      this.LookupData.time = d.toLocaleTimeString();
    }, 1000);
  }
  async ngOnInit() {
    this.model.userclients = localStorage.getItem("userclients");
    this.getclientimage();
    await this.getMenu();
    this.searchScreen();
    await this.getAllEmployee();
    await this.getAllStudent();
    await this.BirthdayStudent();
    await this.BirthdayEmployee();
    await this.getEntity();
    this.dropdown = false

    this.total = this.Etotal + this.Stotal;

  }
  totalScreens = [];
  async getMenu() {

    const dto = await this.menusService.getMenu();
    if (dto.IsSuccess) {
      this.tree = dto.Data;
      if (this.tree && this.tree.length > 0) {
        this.tree.forEach(async element => {
          await this.getID(element.id)
        })
      }
      if (this.parentList.length > 0) {
        this.parentList.forEach(element => {
          element.children.forEach(x => {
            if (element.id === x.parentid) {
              x.parentId = element.parentId;
              // x.label = element.label
              // x.moduleName = element.label
              this.itemList.push(x);
              // this.totalScreens.push(x)
            }
          });
        })
      }
    }
  }

  searchQuery: String;
  filteredData = [];
  searchScreen() {

    this.searchClick();
    if (!this.searchQuery) {
      this.filteredData = this.itemList;
      return;
    }
    this.filteredData = this.itemList.filter(item => {

      return item.label.toLowerCase().includes(this.searchQuery.toLowerCase());
    });
  }

  menuid: any
  itemList = [];
  parentList = [];
  childerList = [];
  async getID(id) {


    if (id) {
      let jsonData = JSON.parse(JSON.stringify(this.tree));
      let filterData = jsonData.filter((o) => o.id === Number(id))[0];
      filterData.children.forEach(element => {
        // element.parentLabel = label
        element.parentId = id
        this.parentList.push(element);
      });

    }

  }
  routeid: any;
  onSuggestionClick(screen) {
    if (this.tree && this.tree.length > 0) {
      let obj = this.tree.find(x => x.id === screen.parentId)
      if (obj) {
        this.routeid = screen.controllerId;
        let screenName = screen.label;
        let parentid = obj.id;
        let parentLable = obj.label;
        let navigationExtras: NavigationExtras = {
          queryParams: {
            menuid: parentid
          },
          replaceUrl: false
        };
        let modulename = this.localStorage.get('modulename')
        let screenname = this.localStorage.get('screenname')
        if (modulename || screenname) {
          this.localStorage.remove('modulename');
          this.localStorage.remove('screenname');
        }
        this.localStorage.set('modulename', parentLable);
        this.localStorage.set('screenname', screenName);
        this.searchQuery = undefined;
        return this.router.navigate([this.routeid], navigationExtras);
      }

    }
  }

  searchClick() {
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.dropdown = true;
    } else if (!this.searchQuery || this.searchQuery == "") {
      this.dropdown = false
    }
  }

  clearSearch() {
    const inputSearch = this.searchInput.nativeElement;
    this.searchQuery = undefined;
    inputSearch.focus();
    this.searchScreen();
  }
  // onInputBlur(){
  //   this.dropdown= false; 
  // }
  onInputFocus() {
    this.dropdown = true;
  }




  async getclientimage() {
    let clients = JSON.parse(this.localStorage.get("userclients"));
    if (clients && clients[0]) {
      var user = clients[0].utuser;
      if (clients && clients[0] && user && user.GNImage) {
        this.rolestxt = user.lov1 ? user.lov1.stxt : "";
        this.url = this.imageSource + user.GNImage.filename;
      }
    }

    this.getCurrenDate();
  }

  title = this.localStorage.get("ClientStxt");
  title_short = this.localStorage.get("ClientCode");
  username = this.localStorage.get("User");
  fullname = this.localStorage.get("Fullname");
  userpic = this.localStorage.get("userpic");
  image = this.localStorage.get("Image");
  EntityLogo = this.localStorage.get("EntityLogo");
  ShortName = this.localStorage.get("ShortName");

  logout() {
    this.localStorage.clear();
    this.navigate("/login");
  }
  async getAllStudent() {
    const dto = await this._SMStudentinfoService.getstudentbirthdays();
    if (dto && dto.Data) {
      dto.Data.forEach(element => {
        var currentdate = new Date();
        var dbo = new Date(element.dateofbirth);
        var age = currentdate.getFullYear() - dbo.getFullYear();
        element.age = age;
      });
      this.LookupData.studentdata = dto.Data;


    }
  }

  async BirthdayStudent() {

    let dateFormat = AppConstants.settings.dateFormatforString;
    let dt = moment(new Date()).format(dateFormat);

    if (this.LookupData.studentdata) {

      let day = new Date(dt).getDate();
      let month = new Date(dt).getMonth();


      // this.studentbirthday = this.LookupData.studentdata.filter(o => new Date(o.DOB).getDate() === day && new Date(o.DOB).getMonth() === month);
      this.studentbirthday = this.LookupData.studentdata;
      this.Stotal = this.studentbirthday && this.studentbirthday.length && this.studentbirthday.length > 0 ? this.studentbirthday.length : 0;

      this.studentbirthday.forEach(element => {

        if (element) {
          element.image = this.imageSource + element.filename;

        }
      });
    }

  }

  async getAllEmployee() {

    const dto = await this._EmployeeinfohdrService.getEmployeeBirthdays();

    if (dto && dto.Data) {
      dto.Data.forEach(element => {
        var currentdate = new Date();
        var dbo = new Date(element.DOB);

        var age = currentdate.getFullYear() - dbo.getFullYear();
        element.age = age;

      });
      this.LookupData.Employeeinfohdr = dto.Data;

    } else {
      this.showErrors(dto.Errors);
    }
  }

  async getEntity() {

    var entitydata: any;
    var utuserents = JSON.parse(localStorage.getItem("utuserents"));
    if (utuserents && utuserents !== null) {
      var entities = [];
      utuserents.forEach(element => {
        entities.push(element.entityid);
      });
      if (entities && entities.length && entities.length > 0)
        entitydata = await this.instituteService.GetUserEntityData(entities)
    }
    if (entitydata && entitydata.Data && entitydata.Data.length && entitydata.Data.length > 0) {
      this.entitycount = entitydata.Data.length;

      entitydata.Data.forEach(element => {

        if (element) {
          element.image = this.imagesourceentity + element.image;

        }
      });
      this.LookupData.instituteList = entitydata.Data;
    }


  }

  async getPolicy(entityid: any) {
    const dto = await this.SystemPolicyservice.getPolicy(entityid);
    if (dto && dto.IsSuccess && dto.Data) {
      AppConstants.policy.dateFormat = dto.Data.dateformat;
      AppConstants.policy.timeFormat = dto.Data.timeformat;
      AppConstants.policy.gridpagging = dto.Data.gridpagging;
      AppConstants.policy.defaultctryid = dto.Data.defaultctryid;
      AppConstants.policy.defaultcityid = dto.Data.defaultcityid;
      // this.loader.stopLoading();
    } else {
      // this.loader.stopLoading();
      // this.errorForm.showErrors(dto.Errors);
    }
    return dto;
  }


  async setselectedEntity(selectedentityid) {
    let entityid = Number(this.localStorage.get("selectedEntity"))
    if (selectedentityid !== entityid) {
      var data = this.LookupData.instituteList.filter(o => o.Id === selectedentityid);
      if (data && data[0])
        this.localStorage.set("ClientStxt", data[0].stxt);

      if (this.localStorage.get("setselectedEntity"))
        this.localStorage.remove("setselectedEntity");

      this.localStorage.set("selectedEntity", selectedentityid);

      if (selectedentityid) {
        let rslt = await this.getPolicy(selectedentityid);
        if (rslt.IsSuccess) {

          // this.startLoading();
          var dto = await this.instituteService.get(selectedentityid);
          if (dto && dto.IsSuccess) {
            // this.stopLoading();
            const legalEntity = dto.Data;

            if (legalEntity) {
              this.localStorage.set("ShortName", legalEntity.shortname);
              // this.loader.startLoading();
              var dtoImage = await this._GNImage.get(legalEntity.imageid);

              if (dtoImage && dtoImage.IsSuccess) {
                // this.loader.stopLoading();
                const gnimage = dtoImage.Data;

                if (gnimage && gnimage.filename) {
                  this.LookupData.imageSource =
                    this.localStorage.get("OnlyUrl") +
                    GenEnum.Image.imageUrl +
                    gnimage.filename;

                  this.localStorage.set("EntityLogo", this.LookupData.imageSource);
                }
                //  else console.log("logo image not found");
              } else {
                // this.loader.stopLoading();

              }
            } else
              console.log("Entity Data does not exist, entityid : " + selectedentityid);

            let utuser = JSON.parse(this.localStorage.get("utuser"));

            if (utuser) {
              if (utuser.usercatid == GenEnum.User_Category.Admin) {
              }

              if (utuser.usercatid == GenEnum.User_Category.Driver) {
              }

              if (utuser.usercatid == GenEnum.User_Category.Employee || utuser.usercatid == GenEnum.User_Category.Admin) {
                let referenceid = utuser.empid;
                if (referenceid) {
                  // this.loader.startLoading();
                  const loginemployee = await this._EmployeeinfohdrService.getLoginUserInfo(referenceid);

                  if (loginemployee && loginemployee.Data) {
                    // this.loader.stopLoading();
                    this.localStorage.set(
                      "LoginUserInfo",
                      JSON.stringify(loginemployee.Data)
                    );
                    if (this.userurl) {
                      this.localStorage.set(
                        "userpic",
                        this.userurl
                      );
                    }
                  } else {
                    // this.loader.stopLoading();
                    console.log("Employee does not exists, id = " + referenceid);
                  }
                } else {
                  // console.log("Employee not define on user");
                  this.errorForm.showErrors("Employee not define on user");
                  return;
                }
              }
            }

            const result = await this.instituteService.getOrganizationStatus();

            if (result && result.IsSuccess && result.Data) {
              this.navigate("home");
              setTimeout(function () {
                window.location.reload();
              }, 2);

            } else {

              var errors = [];
              if (result && result.Errors) {
                result.Errors.forEach(element => {
                  errors.push(element.Description);
                });

                this.errorForm.showErrors(errors, "Information", 1, 2);
                this.navigate("login");
                return;
              }
            }



            // location.reload();
          } else {
            // this.loader.stopLoading();
            this.errorForm.showErrors(
              dto.Errors.length > 0 ? dto.Errors : "Invalid user school"
            );
            //this.navigate("login");
          }
          // this.navigate("home");

        } else {
          this.showErrors(rslt.Errors);
        }
      } else {
        console.log("Entity id does not exists, id = " + selectedentityid);
        this.navigate("login");
      }
    }
  }

  async BirthdayEmployee() {

    let dateFormat = AppConstants.settings.dateFormatforString;
    let dt = moment(new Date()).format(dateFormat);

    if (this.LookupData.Employeeinfohdr) {

      let day = new Date(dt).getDate();
      let month = new Date(dt).getMonth();


      this.birthdayEmployee = this.LookupData.Employeeinfohdr;
      // this.birthdayEmployee = this.LookupData.Employeeinfohdr.filter(o => new Date(o.dateofbirth).getDate() === day && new Date(o.dateofbirth).getMonth() === month);

      this.Etotal = this.birthdayEmployee && this.birthdayEmployee.length && this.birthdayEmployee.length > 0 ? this.birthdayEmployee.length : 0;

      this.birthdayEmployee.forEach(element => {

        if (element.GNImage) {
          element.image = this.imageSource + element.GNImage.filename;

        }
      });
    }

  }

  async getbirthdaymodal() {
    this.birthdaymodal.customOpen();
  }


  async getstudbirthdaymodal(event) {
    await this.stubirthdayScreen.getstudbirthdaymodal(event);
    await this.birthdaymodal.customOpen("md");


  }
  async getempbirthdaymodal(event) {
    await this.EmpbirthdayScreen.getempbirthdaymodal(event);
    await this.empBirthdaymodal.customOpen("md");
  }

  async KeyOpen() {
    this.OpenModal();
  }

  async close() {
    this.closeModal();
  }


  @HostListener("document:keyup", ["$event"]) handleKeyUp(event) {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  }

  closeModal() {
    $(".mask").removeClass("active_modal");
  }

  async OpenModal() {

    $(".mask").addClass("active_modal");
  }

  async changepassword() {
    this.changepass.customOpen("md");
  }
  clickonSearch() {
    this.OpensearchModal();
  }
  @HostListener('document:keydown.escape', ['$event']) // Listen for the "keydown" event on the document
  handleEscapeKey(event: KeyboardEvent) {
    if (this.isModalOpen) {
      this.closeSearchModal();
    }
  }

  closeSearchModal() {
    this.searchQuery = undefined;
    this.dropdown = false;
    this.isModalOpen = false
    $(".searchmask").removeClass("active_search_modal");
  }

  async OpensearchModal() {
    this.isModalOpen = true;
    $(".searchmask").addClass("active_search_modal");
    const modalInput = document.getElementById('searchInput') as HTMLInputElement;
    debugger
    if (modalInput) {
      modalInput.focus();
    }
  }
}










// WEBPACK FOOTER //
// ./src/app/shell/shell-components/navigation-bar.component.ts